(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["promo-modal"] && !Shopify.designMode) return;
  try {
    
  class PromoModal extends HTMLElement {
    #previousFocus = null;

    connectedCallback() {
      if (this.dataset.initialized === 'true') return;
      this.dataset.initialized = 'true';

      if (this.#shouldOpen()) this.#open();
    }

    disconnectedCallback() {
      document.removeEventListener('keydown', this.#handleKeydown);
    }

    #shouldOpen() {
      const trigger = (this.dataset.param || '').trim();
      if (trigger === '') return false;

      const separator = trigger.indexOf('=');
      const key = separator === -1 ? trigger : trigger.slice(0, separator);
      const expected = separator === -1 ? null : trigger.slice(separator + 1);

      const params = new URLSearchParams(window.location.search);
      if (!params.has(key)) return false;
      if (expected !== null && expected !== '' && params.get(key) !== expected) return false;

      if (this.dataset.once === 'true') {
        const storageKey = `promo-modal:${this.id}:${trigger}`;
        try {
          if (sessionStorage.getItem(storageKey) !== null) return false;
          sessionStorage.setItem(storageKey, '1');
        } catch (error) {
          // Private browsing or blocked storage — fall through and show it.
        }
      }

      return true;
    }

    #open() {
      const image = this.querySelector('.promo-modal__image');
      const mobileSrc = this.dataset.srcMobile;
      const useMobile = mobileSrc != null && window.matchMedia('(max-width: 749px)').matches;

      image.src = useMobile ? mobileSrc : this.dataset.src;

      this.#previousFocus = document.activeElement;
      this.hidden = false;
      document.body.style.overflow = 'hidden';
      this.querySelector('.promo-modal__close').focus();

      this.addEventListener('click', this.#close);
      document.addEventListener('keydown', this.#handleKeydown);
    }

    #close = () => {
      this.hidden = true;
      document.body.style.overflow = '';

      this.removeEventListener('click', this.#close);
      document.removeEventListener('keydown', this.#handleKeydown);

      if (this.#previousFocus instanceof HTMLElement) this.#previousFocus.focus();
    };

    #handleKeydown = (event) => {
      if (event.key === 'Escape') this.#close();
    };
  }

  if (!customElements.get('promo-modal')) {
    customElements.define('promo-modal', PromoModal);
  }

  } catch(e) { console.error(e); }
})();
})();
